import React from 'react';
import { Button, Row, Col, Modal } from 'antd';
import moment from 'moment';
import { CloseIcon } from '../../../assets/icons';

import { Images } from '../../../config/images';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const TransferCompleteModal = (props) => {
  const { transferCompleteModal, setTransferCompleteModal, initiateTransferedData } = props;

  const isTransferCompleted = Object.keys(initiateTransferedData).length > 0;
  return (
    <Modal
      open={transferCompleteModal}
      width={524}
      footer={false}
      closeIcon={<CloseIcon />}
      onCancel={() => setTransferCompleteModal(false)}
      centered
    >
      <div className='text-center mb-16'>
        <LazyLoadImage src={Images.success} alt='Tick mark' />
      </div>
      {isTransferCompleted ? (
        <>
          <h4 className='text-center'>Transfer completed</h4>
          <p className='mb-32 text-taupe'>
            Your transfer of <span className='fw-600 text-almost-black'>${initiateTransferedData?.amount}</span> has been initiated. Transfers to and from
            your Realbricks account will take 2 - 5 business days to complete. Exact timing depends on your bank.
          </p>
          <p className='fw-600 mb-4'>Confirmation code:</p>
          <p className='mb-32 text-taupe'>{initiateTransferedData?.confirmationCode}</p>
          <p className='fw-600 mb-4'>Transfer initiated on:</p>
          {/* <p className='mb-48'>Friday, September 30, 2022</p> */}
          <p className='mb-48 text-taupe'>{moment(initiateTransferedData?.date).format('dddd, MMMM DD, YYYY')}</p>
        </>

      ) : (
        <>
          <h4 className='text-center'>Transfer initiated</h4>
          <p className='mb-32 text-taupe'>
            Transfer request created successfully. Your transaction will execute on Admin approval
          </p>
          <p className='fw-600 mb-4'>Transfer initiated on:</p>
          {/* <p className='mb-48'>Friday, September 30, 2022</p> */}
          <p className='mb-48 text-taupe'>{moment(initiateTransferedData?.date).format('dddd, MMMM DD, YYYY')}</p>
        </>
      )}

      <Row gutter={[16, 16]} align='middle'>
        <Col span={24}>
          <Button className='w-100' type='primary' onClick={() => setTransferCompleteModal(false)}>
            Done
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default TransferCompleteModal;
